import { graphql } from "./generated/index.js"

// Mutations ====================================================================

export const createShare = graphql(`
  mutation createShare($object: record_shares_insert_input!) {
    insert_record_shares_one(object: $object) {
      ...RecordShareFields
    }
  }
`)

// Archiving stamps the server's clock ("now()"), not the caller's.
export const archiveShare = graphql(`
  mutation archiveShare($id: Int!) {
    update_record_shares_by_pk(pk_columns: { id: $id }, _set: { archived_at: "now()" }) {
      id
      archived_at
      updated_at
    }
  }
`)

export const unarchiveShare = graphql(`
  mutation unarchiveShare($id: Int!) {
    update_record_shares_by_pk(pk_columns: { id: $id }, _set: { archived_at: null }) {
      id
      archived_at
      updated_at
    }
  }
`)
